// 图片统一域名
export const oUrl = '/static/img/'



// WEBPACK FOOTER //
// ./src/store/types.js